import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="scroll"
export default class extends Controller {
  connect() {
    // console.log("Connected!");
    const messages = document.getElementById("room-messages");
    // messages.addEventListener("DOMNodeInserted", this.resetScroll);
    const observer = new MutationObserver(this.resetScroll);
    observer.observe(messages, {
      childList: true,
      subtree: true,
    });
    this.resetScroll();
  }

  disconnect() {
    console.log("Disconnected!");
  }

  resetScroll() {
    const messages = document.getElementById("room-messages");
    messages.scrollTo({
      top: messages.scrollHeight,
      behavior: "smooth",
    });
  }
}
